import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Composition,
	Easing,
	interpolate,
	Solid,
	useCurrentFrame,
} from 'remotion';

export const CompositionListPreview = () => {
	const frame = useCurrentFrame();

	return (
		<>
			<Solid
				width={1920}
				height={1080}
				color={'#1f2427'}
				style={{
					position: 'absolute',
				}}
			/>
			<AbsoluteFill
				name="Canvas Capture"
				style={{
					width: 1418,
					height: 2634,
					translate: '437.9px -500.5px',
					rotate: '0.875901 0.468151 -0.116756 36.647887deg',
				}}
				from={-449}
			>
				<Video
					src="https://remotion.media/studio-close-ups/composition-list-2026-09-22.mp4"
					style={{
						position: 'absolute',
						transformOrigin: '49.45% 50%',
					}}
					cropRight={0.0111}
				/>
				<MacOSCursor
					cursor={interpolate(
						frame,
						[-446, -439, 437],
						['auto', 'default', 'auto'],
						{
							easing: [Easing.step1, Easing.step1],
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					)}
					style={{
						position: 'absolute',
						left: 0,
						top: 0,
						scale: interpolate(
							frame,
							[
								-449, -208, -204, -35, -30, -2, 2, 100, 107, 182, 185, 228, 234,
								269, 276, 360, 368, 501, 506,
							],
							[
								4.2, 3.7800000000000002, 4.2, 3.7800000000000002, 4.2,
								3.7800000000000002, 4.2, 3.7800000000000002, 4.2,
								3.7800000000000002, 4.2, 3.7800000000000002, 4.2,
								3.7800000000000002, 4.2, 3.7800000000000002, 4.2,
								3.7800000000000002, 4.2,
							],
							{
								easing: [
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
									Easing.step1,
								],
								extrapolateLeft: 'clamp',
								extrapolateRight: 'clamp',
							},
						),
						translate: interpolate(
							frame,
							[
								-446, -445, -444, -443, -442, -441, -440, -439, -438, -437,
								-436, -435, -434, -433, -427, -426, -425, -424, -423, -422,
								-421, -420, -419, -418, -417, -416, -415, -414, -413, -412,
								-411, -410, -409, -408, -407, -406, -364, -363, -362, -317,
								-316, -315, -314, -313, -312, -311, -310, -309, -308, -305,
								-304, -303, -279, -278, -277, -276, -275, -274, -273, -272,
								-271, -270, -269, -268, -267, -266, -263, -262, -261, -260,
								-259, -258, -257, -256, -255, -254, -253, -251, -250, -249,
								-248, -247, -246, -245, -244, -243, -242, -241, -240, -239,
								-238, -237, -236, -235, -234, -233, -232, -231, -230, -229,
								-228, -227, -226, -225, -224, -223, -222, -221, -220, -219,
								-218, -217, -216, -215, -214, -207, -206, -205, -200, -199,
								-198, -197, -196, -195, -194, -193, -192, -171, -170, -169,
								-168, -167, -166, -165, -164, -163, -162, -143, -142, -141,
								-140, -139, -138, -137, -136, -135, -134, -133, -132, -131,
								-130, -129, -127, -126, -125, -124, -123, -122, -121, -120,
								-119, -118, -117, -100, -99, -98, -97, -96, -95, -94, -93, -92,
								-91, -90, -89, -88, -87, -86, -85, -84, -83, -82, -81, -80, -79,
								-78, -77, -76, -75, -74, -73, -72, -71, -70, -69, -68, -67, -66,
								-65, -64, -63, -62, -61, -60, -59, -58, -57, 22, 23, 24, 25, 26,
								27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42,
								43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58,
								59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74,
								75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
								91, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143,
								144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156,
								157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169,
								170, 171, 172, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198,
								199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211,
								212, 213, 214, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298,
								299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311,
								312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324,
								325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337,
								338, 339, 365, 366, 367, 430, 431, 432, 433, 434, 435, 436, 437,
								438, 439, 440, 441, 442, 443, 444, 445, 446, 447, 448, 449, 450,
								451, 452, 453, 454, 455, 456, 457, 458, 459, 460, 461, 462, 463,
								464, 465, 466, 467, 468, 469, 470, 471, 472, 473, 474, 475, 476,
								477, 478, 479, 480, 481, 482, 483, 484, 485, 486, 487, 488, 489,
								490, 491, 492, 493, 494, 495, 496, 497, 498, 499,
							],
							[
								'3747.4828125000004px 3917.8453125px',
								'3728.7468750000003px 3898.2234375000003px',
								'3633.0492187500004px 3805.8562500000003px',
								'3633.0492187500004px 3805.8562500000003px',
								'3397.9148437500003px 3591.8367187500003px',
								'1714.3875px 2186.83828125px',
								'1387.4437500000001px 1860.9609375px',
								'1021.1906250000001px 1463.45390625px',
								'807.03984375px 1221.8226562500001px',
								'695.4445312500001px 1074.1664062500001px',
								'661.61484375px 1007.26171875px',
								'655.70859375px 980.5851562500001px',
								'655.4625px 968.2804687500001px',
								'655.4625px 967.4273437500001px',
								'655.4625px 967.4273437500001px',
								'653.4609375px 966.91875px',
								'637.2843750000001px 962.43984375px',
								'573.9234375px 949.6265625000001px',
								'550.6593750000001px 943.3429687500001px',
								'542.8664062500001px 929.5125px',
								'524.7703125px 894.3046875px',
								'508.20000000000005px 866.1515625000001px',
								'508.20000000000005px 866.1515625000001px',
								'509.33203125px 865.4625000000001px',
								'517.65px 864.5765625px',
								'555.45px 866.1187500000001px',
								'594.11953125px 877.3734375px',
								'632.47734375px 899.89921875px',
								'639.384375px 910.4156250000001px',
								'650.7046875px 934.2867187500001px',
								'655.9875000000001px 954.10546875px',
								'657.74296875px 970.2492187500001px',
								'657.825px 978.15703125px',
								'657.3820312500001px 979.9781250000001px',
								'657.08671875px 981.028125px',
								'657.0703125px 981.47109375px',
								'657.0703125px 981.47109375px',
								'656.5617187500001px 981.47109375px',
								'656.43046875px 981.47109375px',
								'656.43046875px 981.47109375px',
								'656.43046875px 981.50390625px',
								'656.43046875px 995.859375px',
								'656.43046875px 1112.7046875px',
								'652.00078125px 1282.29609375px',
								'635.5453125px 1441.51875px',
								'617.8921875px 1557.88828125px',
								'607.40859375px 1604.44921875px',
								'599.4515625px 1625.3507812500002px',
								'598.28671875px 1628.15625px',
								'598.28671875px 1628.15625px',
								'598.61484375px 1628.15625px',
								'598.8937500000001px 1628.15625px',
								'598.8937500000001px 1628.15625px',
								'597.84375px 1629.1898437500001px',
								'597.84375px 1629.1898437500001px',
								'492.1875px 1736.8148437500001px',
								'457.17656250000005px 1798.69921875px',
								'453.71484375px 1886.8171875px',
								'482.39296875px 2016.196875px',
								'503.77031250000005px 2081.60859375px',
								'523.359375px 2126.95546875px',
								'530.9390625px 2150.15390625px',
								'530.7257812500001px 2154.8953125000003px',
								'529.21640625px 2160.45703125px',
								'527.37890625px 2163.39375px',
								'526.49296875px 2164.62421875px',
								'526.49296875px 2164.62421875px',
								'526.4109375px 2166.36328125px',
								'522.375px 2182.5234375px',
								'502.93359375px 2230.31484375px',
								'476.45390625000005px 2293.08515625px',
								'451.97578125px 2353.3453125px',
								'441.80390625px 2378.06953125px',
								'435.01171875px 2390.8992187500003px',
								'431.94375px 2397.7078125000003px',
								'429.84375px 2402.0390625px',
								'429.31875px 2402.64609375px',
								'429.31875px 2402.64609375px',
								'430.171875px 2394.9515625px',
								'430.171875px 2394.9515625px',
								'418.47421875000003px 2183.39296875px',
								'375.98203125000003px 1970.259375px',
								'323.05546875px 1720.8515625px',
								'300.11953125px 1542.00703125px',
								'288.29062500000003px 1386.65625px',
								'288.29062500000003px 1367.3296875px',
								'288.66796875px 1363.0804687500001px',
								'290.43984375px 1347.0515625px',
								'293.72109375px 1329.54609375px',
								'296.96953125px 1311.00703125px',
								'299.2171875px 1285.5609375000001px',
								'299.69296875000003px 1270.84453125px',
								'300.1359375px 1262.3625px',
								'300.9890625px 1245.3656250000001px',
								'301.48125px 1234.98046875px',
								'301.48125px 1224.25078125px',
								'301.82578125000003px 1212.1429687500001px',
								'302.97421875000003px 1183.00546875px',
								'303.909375px 1156.65703125px',
								'304.828125px 1131.81796875px',
								'305.86171875px 1117.61015625px',
								'306.8953125px 1093.82109375px',
								'308.45390625px 1074.06796875px',
								'309.225px 1053.10078125px',
								'309.225px 1042.30546875px',
								'309.225px 1032.8390625px',
								'309.225px 1026.9px',
								'309.225px 1018.9265625px',
								'309.225px 1008.6890625000001px',
								'309.7171875px 999.3703125000001px',
								'309.75px 995.4328125000001px',
								'309.75px 988.8046875px',
								'309.75px 983.2265625px',
								'309.70078125000003px 981.88125px',
								'309.56953125px 981.5203125px',
								'309.56953125px 981.5203125px',
								'309.56953125px 981.3234375000001px',
								'309.56953125px 980.8804687500001px',
								'309.56953125px 980.8804687500001px',
								'313.47421875000003px 981.684375px',
								'341.64375px 985.40859375px',
								'380.47734375px 990.7242187500001px',
								'435.01171875px 997.25390625px',
								'475.56796875000003px 1001.19140625px',
								'517.86328125px 1003.91484375px',
								'544.90078125px 1005.9328125000001px',
								'548.296875px 1006.3101562500001px',
								'548.296875px 1006.3101562500001px',
								'548.83828125px 1006.3101562500001px',
								'556.28671875px 1007.9015625000001px',
								'575.4px 1011.7570312500001px',
								'628.76953125px 1018.3359375px',
								'628.76953125px 1018.3359375px',
								'664.2726562500001px 1022.97890625px',
								'664.2726562500001px 1022.97890625px',
								'672.41015625px 1024.1109375px',
								'677.36484375px 1025.34140625px',
								'677.36484375px 1025.34140625px',
								'677.36484375px 1025.6039062500001px',
								'677.03671875px 1027.86796875px',
								'676.6921875px 1029.47578125px',
								'673.771875px 1020.1734375000001px',
								'673.771875px 1020.1734375000001px',
								'634.18359375px 962.9976562500001px',
								'597.36796875px 913.35234375px',
								'562.8820312500001px 872.7632812500001px',
								'523.3265625px 822.62578125px',
								'505.59140625000003px 789.1734375px',
								'503.72109375px 781.4625px',
								'503.91796875px 777px',
								'504.6234375px 774.8015625px',
								'504.77109375000003px 774.4406250000001px',
								'504.77109375000003px 774.4406250000001px',
								'505.70625px 774.4406250000001px',
								'512.1703125px 775.621875px',
								'527.01796875px 788.5171875px',
								'545.1140625px 820.9195312500001px',
								'558.6328125px 858.9984375px',
								'558.6328125px 858.9984375px',
								'580.83046875px 925.6242187500001px',
								'593.69296875px 964.2281250000001px',
								'596.8265625px 974.6460937500001px',
								'598.02421875px 979.453125px',
								'598.02421875px 979.453125px',
								'594.9890625px 978.84609375px',
								'579.1734375px 974.53125px',
								'557.10703125px 959.9132812500001px',
								'538.25625px 937.9125px',
								'524.88515625px 915.3046875px',
								'514.9921875px 898.340625px',
								'507.39609375000003px 886.44609375px',
								'496.453125px 867.365625px',
								'495.271875px 860.1796875px',
								'493.959375px 845.33203125px',
								'492.72890625px 833.765625px',
								'489.28359375px 823.0851562500001px',
								'485.73984375000003px 816.375px',
								'480.91640625px 806.7609375000001px',
								'474.00937500000003px 793.32421875px',
								'459.75234375px 772.7015625px',
								'450.69609375000005px 758.5265625000001px',
								'447.4640625px 747.928125px',
								'447.4640625px 740.0859375px',
								'447.4640625px 732.2109375px',
								'447.61171875px 727.1085937500001px',
								'448.16953125000003px 721.3171875px',
								'448.79296875px 713.4421875px',
								'449.48203125000003px 703.3195312500001px',
								'449.596875px 695.54296875px',
								'449.58046875px 688.84921875px',
								'449.08828125px 683.2875px',
								'449.08828125px 679.5796875px',
								'448.90781250000003px 675.1828125000001px',
								'448.59609375px 669.42421875px',
								'448.59609375px 662.69765625px',
								'448.59609375px 649.4578125px',
								'448.59609375px 639.8765625px',
								'448.59609375px 639.8765625px',
								'447.31640625px 617.5148437500001px',
								'447.0375px 609.60703125px',
								'446.25px 603.0773437500001px',
								'446.06953125px 599.36953125px',
								'445.8890625px 596.81015625px',
								'445.8890625px 595.13671875px',
								'445.8890625px 594.74296875px',
								'446.26640625000005px 594.74296875px',
								'446.28281250000003px 594.74296875px',
								'446.28281250000003px 594.74296875px',
								'446.29921875px 594.74296875px',
								'448.72734375000005px 594.74296875px',
								'452.35312500000003px 595.3171875px',
								'454.66640625px 596.74453125px',
								'457.0453125px 598.63125px',
								'458.3578125px 601.1906250000001px',
								'459.65390625000003px 605.0296875px',
								'460.08046875px 612.49453125px',
								'460.96640625000003px 622.059375px',
								'461.671875px 629.0812500000001px',
								'461.671875px 629.0812500000001px',
								'462.31171875px 644.2570312500001px',
								'462.31171875px 644.2570312500001px',
								'462.31171875px 667.75078125px',
								'462.31171875px 667.75078125px',
								'462.31171875px 701.9250000000001px',
								'463.01718750000003px 727.0921875px',
								'463.01718750000003px 727.0921875px',
								'463.771875px 746.0578125000001px',
								'463.95234375px 766.303125px',
								'464.83828125px 802.1015625px',
								'464.98593750000003px 825.11953125px',
								'466.003125px 853.4859375000001px',
								'466.003125px 853.4859375000001px',
								'467.06953125px 886.85625px',
								'469.41562500000003px 939.33984375px',
								'471.56484375px 972.41484375px',
								'471.56484375px 972.41484375px',
								'473.221875px 995.6789062500001px',
								'473.94375px 1009.575px',
								'474.8625px 1039.4015625px',
								'475.53515625px 1057.21875px',
								'475.53515625px 1057.21875px',
								'475.53515625px 1071.3609375px',
								'475.53515625px 1087.2421875px',
								'475.53515625px 1103.3859375px',
								'475.53515625px 1117.24921875px',
								'475.53515625px 1124.92734375px',
								'475.53515625px 1149.1921875px',
								'475.53515625px 1149.1921875px',
								'475.53515625px 1166.090625px',
								'475.53515625px 1181.25px',
								'475.53515625px 1198.4109375px',
								'475.53515625px 1212.5203125px',
								'475.53515625px 1233.40546875px',
								'475.53515625px 1255.22578125px',
								'474.81328125000005px 1277.4890625px',
								'473.79609375px 1303.42734375px',
								'472.7296875px 1340.1937500000001px',
								'472.7296875px 1365.31171875px',
								'472.7296875px 1383.78515625px',
								'472.45078125000003px 1409.3460937500001px',
								'471.646875px 1428.27890625px',
								'471.26953125px 1445.47265625px',
								'470.62968750000005px 1463.45390625px',
								'469.82578125000003px 1480.7132812500001px',
								'469.07109375000005px 1493.08359375px',
								'467.66015625px 1507.42265625px',
								'467.16796875px 1517.43046875px',
								'467.00390625px 1526.9625px',
								'466.64296875px 1536.9703125px',
								'466.11796875000005px 1547.58515625px',
								'465.675px 1555.06640625px',
								'465.37968750000005px 1559.971875px',
								'465.346875px 1562.0390625px',
								'465.346875px 1564.565625px',
								'465.01875px 1565.8617187500001px',
								'465.01875px 1566.25546875px',
								'465.01875px 1566.41953125px',
								'465.01875px 1566.41953125px',
								'465.01875px 1566.2390625px',
								'464.08359375000003px 1562.79375px',
								'459.22734375000005px 1546.2234375px',
								'455.6671875px 1523.56640625px',
								'455.6671875px 1523.56640625px',
								'453.82968750000003px 1484.09296875px',
								'453.3703125px 1423.98046875px',
								'456.61875000000003px 1350.2671875px',
								'458.25937500000003px 1306.2984375px',
								'460.72031250000003px 1254.07734375px',
								'461.88515625px 1216.0640625px',
								'464.05078125px 1165.696875px',
								'465.23203125000003px 1137.4453125px',
								'469.00546875000003px 1091.671875px',
								'471.36796875000005px 1061.8453125px',
								'472.69687500000003px 1029.39375px',
								'473.0578125px 1002.96328125px',
								'473.0578125px 975.0890625000001px',
								'473.0578125px 948.3960937500001px',
								'473.0578125px 922.4742187500001px',
								'473.27109375000003px 902.6554687500001px',
								'474.15703125000005px 879.2765625000001px',
								'474.534375px 864.871875px',
								'474.534375px 847.2023437500001px',
								'474.534375px 830.7796875px',
								'474.534375px 813.1921875px',
								'474.534375px 800.821875px',
								'475.27265625px 784.875px',
								'475.27265625px 768.3046875px',
								'475.27265625px 758.2640625px',
								'475.27265625px 748.25625px',
								'475.27265625px 742.30078125px',
								'475.27265625px 739.61015625px',
								'475.25625px 739.59375px',
								'474.8625px 738.80625px',
								'474.74765625000003px 738.46171875px',
								'474.18984375px 736.771875px',
								'473.86171875px 736.0171875px',
								'473.8125px 735.328125px',
								'473.6484375px 735.328125px',
								'473.6484375px 735.328125px',
								'472.35234375000005px 734.03203125px',
								'472.35234375000005px 734.03203125px',
								'469.35px 728.30625px',
								'467.66015625px 720.3328125px',
								'466.7578125px 710.1281250000001px',
								'466.74140625px 682.5328125px',
								'466.83984375px 670.93359375px',
								'466.83984375px 670.93359375px',
								'467.79140625px 651.67265625px',
								'468.25078125000005px 643.6828125000001px',
								'468.64453125px 632.953125px',
								'468.64453125px 625.45546875px',
								'469.03828125px 616.6125000000001px',
								'469.20234375px 610.44375px',
								'469.20234375px 604.29140625px',
								'469.20234375px 598.84453125px',
								'469.20234375px 593.95546875px',
								'468.8578125px 590.7234375px',
								'467.72578125px 587.146875px',
								'467.11875000000003px 584.4562500000001px',
								'466.46250000000003px 581.78203125px',
								'466.03593750000005px 579.48515625px',
								'465.5765625px 577.58203125px',
								'465.33046875px 577.040625px',
								'465.31406250000003px 577.0078125px',
								'465.31406250000003px 577.0078125px',
								'465.92109375px 577.303125px',
								'467.18437500000005px 579.271875px',
								'468.18515625000003px 588.8859375000001px',
								'468.33281250000005px 601.33828125px',
								'467.62734375px 616.49765625px',
								'466.396875px 626.27578125px',
								'464.00156250000003px 641.0578125000001px',
								'462.14765625px 651.34453125px',
								'460.425px 663.35390625px',
								'460.12968750000005px 671.5078125px',
								'460.12968750000005px 679.546875px',
								'460.12968750000005px 686.5851562500001px',
								'460.753125px 698.95546875px',
								'460.8515625px 708.8484375px',
								'460.8515625px 721.46484375px',
								'460.95000000000005px 736.03359375px',
								'461.39296875px 747.6px',
								'461.68828125000005px 762.15234375px',
								'462.13125px 782.0203125px',
								'462.13125px 800.3625000000001px',
								'462.8859375px 824.8734375px',
								'463.06640625px 838.5070312500001px',
								'463.06640625px 859.29375px',
								'463.06640625px 876.43828125px',
								'463.06640625px 894.6328125px',
								'463.06640625px 915.0093750000001px',
								'463.06640625px 943.3101562500001px',
								'463.06640625px 969.4453125px',
								'463.06640625px 994.8257812500001px',
								'463.06640625px 1018.9921875px',
								'462.5578125px 1034.20078125px',
								'462.47578125px 1057.6453125px',
								'461.86875000000003px 1075.44609375px',
								'461.86875000000003px 1097.75859375px',
								'461.86875000000003px 1114.575px',
								'461.86875000000003px 1133.86875px',
								'461.86875000000003px 1144.5492187500001px',
								'461.86875000000003px 1151.2757812500001px',
								'461.86875000000003px 1156.5257812500001px',
								'461.86875000000003px 1165.2375px',
								'461.86875000000003px 1170.66796875px',
								'462.37734375px 1176.7054687500001px',
								'462.37734375px 1179.10078125px',
								'462.37734375px 1180.8070312500001px',
								'462.37734375px 1182.57890625px',
								'462.37734375px 1183.36640625px',
								'462.37734375px 1183.7765625px',
								'462.37734375px 1184.15390625px',
								'462.37734375px 1184.596875px',
								'462.37734375px 1184.64609375px',
								'462.37734375px 1184.64609375px',
								'462.42656250000005px 1184.64609375px',
								'462.984375px 1184.64609375px',
								'462.984375px 1184.64609375px',
								'464.953125px 1189.0921875000001px',
								'507.33046875px 1261.0828125px',
								'670.03125px 1491.7054687500001px',
								'886.4953125000001px 1769.775px',
								'1115.11640625px 2064.84140625px',
								'1305.85546875px 2306.6531250000003px',
								'1500.778125px 2540.3109375px',
								'1690.434375px 2758.678125px',
								'1803.7359375px 2886.49921875px',
								'1886.3578125000001px 2975.7000000000003px',
								'1938.41484375px 3034.0078125px',
								'1993.29375px 3093.5625px',
								'2053.45546875px 3152.1984375px',
								'2116.0945312500003px 3206.6179687500003px',
								'2152.5328125px 3235.3289062500003px',
								'2186.428125px 3257.1000000000004px',
								'2224.6218750000003px 3279.9703125px',
								'2268.328125px 3308.40234375px',
								'2327.01328125px 3341.4609375px',
								'2388.0281250000003px 3373.37109375px',
								'2462.578125px 3404.37890625px',
								'2582.16328125px 3447.59296875px',
								'2749.57265625px 3500.88046875px',
								'2918.39296875px 3546.32578125px',
								'3052.5632812500003px 3577.62890625px',
								'3167.21015625px 3602.3695312500004px',
								'3256.509375px 3618.7429687500003px',
								'3293.7679687500004px 3624.4031250000003px',
								'3313.1273437500004px 3627.37265625px',
								'3327.8601562500003px 3629.8992187500003px',
								'3337.7367187500004px 3631.3757812500003px',
								'3342.15px 3631.7367187500004px',
								'3354.20859375px 3633.1312500000004px',
								'3375.421875px 3635.11640625px',
								'3408.2507812500003px 3637.3148437500004px',
								'3425.6414062500003px 3639.43125px',
								'3450.38203125px 3642.4007812500004px',
								'3463.50703125px 3645.5671875000003px',
								'3479.09296875px 3653.29453125px',
								'3501.1265625px 3667.1578125px',
								'3520.92890625px 3682.1039062500004px',
								'3533.25px 3691.8656250000004px',
								'3549.7054687500004px 3708.0750000000003px',
								'3564.7992187500004px 3727.5492187500004px',
								'3571.75546875px 3739.1976562500004px',
								'3578.6296875000003px 3752.3390625px',
								'3584.02734375px 3761.5921875000004px',
								'3593.625px 3775.5867187500003px',
								'3602.30390625px 3786.43125px',
								'3608.2429687500003px 3792.8460937500004px',
								'3615.9539062500003px 3800.015625px',
								'3626.4867187500004px 3809.12109375px',
								'3635.1984375px 3815.765625px',
								'3643.58203125px 3821.1796875px',
								'3650.5710937500003px 3825.3304687500004px',
								'3658.67578125px 3828.67734375px',
								'3670.0453125000004px 3833.0578125px',
								'3683.7117187500003px 3837.3562500000003px',
								'3691.81640625px 3839.3578125000004px',
								'3704.9085937500004px 3841.6218750000003px',
								'3714.6046875px 3843.47578125px',
								'3727.5px 3849.5625px',
								'3736.096875px 3854.7796875000004px',
								'3745.1531250000003px 3861.52265625px',
								'3751.6171875px 3866.37890625px',
								'3754.3078125px 3868.7250000000004px',
								'3754.7015625000004px 3869.0531250000004px',
								'3754.9968750000003px 3869.0531250000004px',
								'3755.0953125px 3869.0531250000004px',
							],
							{
								extrapolateLeft: 'clamp',
								extrapolateRight: 'clamp',
							},
						),
					}}
				/>
			</AbsoluteFill>
		</>
	);
};

export const CompositionList = () => {
	return (
		<Composition
			id="CompositionList"
			component={CompositionListPreview}
			width={1920}
			height={1080}
			fps={60}
			durationInFrames={983}
		/>
	);
};
